const usuarios = angular.module('usuarios', [])

usuarios.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.usuarios',
            url: '/usuarios',
            params: { showGlobalLoading: { dynamic: true, value: false } },
            component: 'usuarios.usuariosComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);